import { StandingsTableView } from '@/features/standings/StandingsTableView';
import { usePageTitle } from '@/shared/hooks/usePageTitle';
import { useTournamentData } from '@/features/tournament/useTournamentData';
import { Alert } from '@/shared/ui/Alert';
import { LoadingScreen } from '@/shared/ui/LoadingScreen';
import { PageState } from '@/shared/ui/PageState';

/** Reads the number of qualifying places out of the phase configuration. */
function qualifyingRanksOf(config: unknown): number {
  if (typeof config === 'object' && config !== null && 'qualifiersPerGroup' in config) {
    const value = config.qualifiersPerGroup;
    return typeof value === 'number' ? value : 0;
  }
  return 0;
}

export function GroupsPage() {
  usePageTitle('Gruppen');
  const { tournament, myTeam, lookup, phases, isLoading, errorMessage } = useTournamentData();

  if (isLoading) {
    return <LoadingScreen label="Gruppen werden geladen …" />;
  }

  if (errorMessage !== null) {
    return <PageState title="Gruppen nicht verfügbar" description={errorMessage} />;
  }

  const withTables = phases.filter((phase) => phase.standings.length > 0);

  if (withTables.length === 0) {
    return <Alert tone="info">Es gibt noch keine Gruppen — das Turnier ist nicht gestartet.</Alert>;
  }

  return (
    <div className="flex flex-col gap-8">
      <h1 className="text-2xl font-bold tracking-tight">Gruppen</h1>

      {withTables.map((phase) => {
        const config = tournament?.settings.phases.find(
          (candidate) => candidate.id === phase.phaseId,
        )?.config;

        return (
          <section key={phase.phaseId} className="flex flex-col gap-4">
            <div className="flex flex-col gap-1">
              <h2 className="text-lg font-semibold">{phase.label}</h2>
              <p className="text-fg-subtle text-xs">
                Grün hinterlegt: Plätze, die sich für die nächste Runde qualifizieren.
              </p>
            </div>

            <div className="grid gap-4 lg:grid-cols-2">
              {phase.standings.map((table) => (
                <StandingsTableView
                  key={table.groupId ?? table.label}
                  table={table}
                  lookup={lookup}
                  qualifyingRanks={qualifyingRanksOf(config)}
                  highlightTeamId={myTeam?.id}
                />
              ))}
            </div>
          </section>
        );
      })}
    </div>
  );
}
